export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7504.0e1080ad.jpg";